import './components/burger.js'
import './components/modal.js'
import './components/cookie.js'
import './components/form.js'
import './components/count.js'
import './components/line.js'
import './components/quiz.js'
import './components/slider.js'
import './components/map.js'
